import {useState,useCallback,useMemo,useRef} from 'react';
import Modal from '../../components/Modal';
import Topbar from '../../components/Topbar';
import {useProdutos} from './hooks/useProdutos';
import {ABAS,CLASSES_ORDER,CATEGORIAS,GRUPOS_COMPRADOS,GRUPOS_FABRICACAO,GRUPOS_MONTAGEM,UNIDADES,TIPOS_ITEM,TIPO_MONTAGEM_MAP,SEP_STYLE} from './constants';
import {LinhaItem,LinhaSimples,LinhaFinal,TabelaGrupos,TabelaFinal} from './components/TabelaProdutos';

export default function ProdutosLista(){
  const {produtos,maquinas,funcionarios,loading,salvando,form,modalForm,setForm,setF,atualizarProduto,abrirNovo,abrirEditar,fecharModal,excluir,duplicar,salvar}=useProdutos();
  const [busca,setBusca]=useState('');
  const [aba,setAba]=useState('PF_TODOS');

  const openMapRef=useRef({});
  const [,forceUpdate]=useState(0);
  const toggleOpen=useCallback((id)=>{openMapRef.current[id]=!openMapRef.current[id];forceUpdate(v=>v+1);},[]);

  const abaAtual=ABAS.find(a=>a.key===aba);
  const produtosFiltrados=useMemo(()=>produtos
    .filter(p=>p.grupo===abaAtual.grupo)
    .filter(p=>!abaAtual.cliente||(p.tabela_precos||[]).some(tp=>tp.tipo_cliente===abaAtual.cliente))
    .filter(p=>p.nome.toLowerCase().includes(busca.toLowerCase())||p.codigo.toLowerCase().includes(busca.toLowerCase()))
  ,[produtos,abaAtual,busca]);

  const countAba=useCallback((a)=>{
    let l=produtos.filter(p=>p.grupo===a.grupo);
    if(a.cliente)l=l.filter(p=>(p.tabela_precos||[]).some(tp=>tp.tipo_cliente===a.cliente));
    return l.length;
  },[produtos]);

  const linhaProps=useMemo(()=>({onExcluir:excluir,onDuplicar:duplicar,atualizarProduto,maquinas,funcionarios,produtos}),[excluir,duplicar,atualizarProduto,maquinas,funcionarios,produtos]);

  const renderConteudo=()=>{
    if(loading)return <div className='table-empty'>Carregando...</div>;
    if(!produtosFiltrados.length)return <div className='table-empty'>Nenhum produto encontrado.</div>;
    if(abaAtual.grupo==='COMPRADOS')return(
      <table>
        <thead><tr><th>Codigo</th><th>Nome</th><th>Unidade</th><th>Custo</th><th></th></tr></thead>
        <tbody>{GRUPOS_COMPRADOS.map(g=>{
          const itens=produtosFiltrados.filter(g.filter).slice().sort((a,b)=>a.codigo.localeCompare(b.codigo));
          if(!itens.length)return null;
          return[
            <tr key={'h-'+g.label}><td colSpan={5} style={SEP_STYLE}>{g.label} <span style={{fontWeight:400}}>({itens.length})</span></td></tr>,
            ...itens.map(p=><LinhaItem key={p.id} p={p} open={!!openMapRef.current[p.id]} onToggle={()=>toggleOpen(p.id)} onExcluir={excluir} onAtualizar={()=>atualizarProduto(p.id)}/>),
          ];
        })}</tbody>
      </table>
    );
    if(abaAtual.grupo==='FABRICACAO')return <TabelaGrupos grupos={GRUPOS_FABRICACAO} lista={produtosFiltrados} linhaProps={linhaProps} openMap={openMapRef.current} onToggle={toggleOpen}/>;
    if(abaAtual.grupo==='MONTAGEM')return <TabelaGrupos grupos={GRUPOS_MONTAGEM} lista={produtosFiltrados} linhaProps={linhaProps} openMap={openMapRef.current} onToggle={toggleOpen}/>;
    return <TabelaFinal lista={produtosFiltrados} cliente={abaAtual.cliente} abaLabel={ABAS.find(a=>a.cliente===abaAtual.cliente)?.label} linhaProps={linhaProps} openMap={openMapRef.current} onToggle={toggleOpen}/>;
  };

  const campo=(label,field,opts={})=>(
    <div className='form-group'>
      <label className='form-label'>{label}</label>
      {opts.select
        ? <select className='form-select' value={form[field]||''} onChange={e=>setF(field,e.target.value)}>
            {opts.options.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
          </select>
        : <input className='form-input' value={form[field]||''} onChange={e=>setF(field,e.target.value)} placeholder={opts.placeholder||''} type={opts.type||'text'}/>
      }
    </div>
  );

  const tipoMontagemAtual=TIPO_MONTAGEM_MAP.find(t=>t.v!==''&&t.categoria===form.categoria&&(t.tipo===''||t.tipo===(form.tipo||''))&&(t.classe===''||t.classe===(form.classe||'')))?.v||'';
  const setTipoMontagem=(v)=>{const t=TIPO_MONTAGEM_MAP.find(x=>x.v===v);if(t)setForm(f=>({...f,categoria:t.categoria,tipo:t.tipo,classe:t.classe}));};
  const handleSalvar=()=>{
    const cA=(form.categoria==='SEMIACABADO'&&['ROLDANA','ROLDANA_GANCHO'].includes(form.tipo))?'ROLDANAS':form.classe;
    const oA=['SEMIACABADO','MONTAGEM_VARAL','MONTAGEM_KIT','MONTAGEM_MV'].includes(form.categoria)?'FABRICADO':form.origem;
    salvar(cA,oA);
  };

  const isMontagem = ['MONTAGEM_VARAL','MONTAGEM_KIT','MONTAGEM_MV','SEMIACABADO'].includes(form.categoria);
  const isFabricacao = ['INJECAO_PLASTICA','CORTE_BARRA_ALU','TRANCAGEM_CORDA'].includes(form.categoria);
  const isPF = form.categoria === 'PRODUTO_FINAL';
  const isComp = !isMontagem && !isFabricacao && !isPF;

  const footer=(
    <>
      <button className='btn btn-secondary' onClick={fecharModal}>Cancelar</button>
      <button className='btn btn-primary' onClick={handleSalvar} disabled={salvando}>{salvando?'Salvando...':'Salvar'}</button>
    </>
  );

  return(<>
    <Topbar title='Produtos'/>
    <div className='erp-content'>
      <div className='page-toolbar'>
        {abaAtual.grupo==='PRODUTO_FINAL'&&<button className='btn btn-primary' onClick={()=>abrirNovo()}><i className='ti ti-plus'/> Novo produto final</button>}
        {abaAtual.grupo==='FABRICACAO'&&<button className='btn btn-primary' onClick={()=>abrirNovo({origem:'FABRICADO',categoria:'CORTE_BARRA_ALU'})}><i className='ti ti-plus'/> Nova peca fabricada</button>}
        {abaAtual.grupo==='MONTAGEM'&&<button className='btn btn-primary' onClick={()=>abrirNovo({origem:'FABRICADO',categoria:'SEMIACABADO'})}><i className='ti ti-plus'/> Nova montagem</button>}
        {abaAtual.grupo==='COMPRADOS'&&<button className='btn btn-primary' onClick={()=>abrirNovo({origem:'COMPRADO',categoria:'COMP_COMPRADO'})}><i className='ti ti-plus'/> Novo componente</button>}
        <input className='form-input' style={{width:260}} placeholder='Buscar por nome ou codigo...' value={busca} onChange={e=>setBusca(e.target.value)}/>
      </div>
      <div className='abas-wrapper' style={{marginBottom:16}}>
        <div className='abas' style={{flexWrap:'wrap'}}>
          {ABAS.map(a=><button key={a.key} className={'aba'+(aba===a.key?' aba-ativa':'')} onClick={()=>setAba(a.key)}>{a.label} <span className='aba-count'>{countAba(a)}</span></button>)}
        </div>
      </div>
      <div className='card'><div className='table-wrapper'>{renderConteudo()}</div></div>
    </div>

    {modalForm&&(
      <Modal
        title={modalForm==='novo'?'Novo produto':'Editar produto'}
        onClose={fecharModal}
        size='lg'
        footer={footer}
      >
        <div className='form-grid'>
          {campo('Codigo','codigo',{placeholder:'Ex: PF-ABR-BCA'})}
          {campo('Nome','nome',{placeholder:'Nome do produto'})}
          {isMontagem
            ? <div className='form-group'>
                <label className='form-label'>Tipo de montagem</label>
                <select className='form-select' value={tipoMontagemAtual} onChange={e=>setTipoMontagem(e.target.value)}>
                  {TIPO_MONTAGEM_MAP.map(t=><option key={t.v} value={t.v}>{t.l}</option>)}
                </select>
              </div>
            : campo('Categoria','categoria',{select:true,options:CATEGORIAS.map(c=>({v:c.key,l:c.label}))})
          }
          {campo('Unidade','unidade',{select:true,options:UNIDADES})}
        </div>

        {isPF&&(
          <>
            <div className='form-section'>Classificacao e Preco</div>
            <div className='form-grid'>
              {campo('Classe','classe',{select:true,options:[{v:'',l:'-- Selecione --'},...CLASSES_ORDER.filter(c=>c.key!=='').map(c=>({v:c.key,l:c.label}))]})}
              {campo('Origem','origem',{select:true,options:[{v:'COMPRADO',l:'Comprado'},{v:'FABRICADO',l:'Fabricado'},{v:'AMBOS',l:'Comprado e Fabricado'}]})}
              {campo('Preco de custo','preco_custo',{type:'number'})}
            </div>
            <div className='form-section'>Dados Fiscais</div>
            <div className='form-grid'>
              {campo('NCM','ncm')}
              {campo('CFOP','cfop')}
              {campo('CSOSN/CST','csosn')}
              {campo('EAN','ean')}
            </div>
          </>
        )}

        {(isFabricacao||isComp)&&(
          <>
            <div className='form-section'>Dados</div>
            <div className='form-grid'>
              {campo('Origem','origem',{select:true,options:[{v:'COMPRADO',l:'Comprado'},{v:'FABRICADO',l:'Fabricado'},{v:'AMBOS',l:'Comprado e Fabricado'}]})}
              {campo('Preco de custo','preco_custo',{type:'number'})}
            </div>
          </>
        )}

        <div className='form-section'>Estoque</div>
        <div className='form-grid'>
          {campo('Estoque atual','estoque',{type:'number'})}
          {campo('Estoque minimo','estoque_minimo',{type:'number'})}
        </div>

        <div className='form-section'>Descricao</div>
        <div className='form-group'>
          <textarea className='form-input' rows={3} value={form.descricao||''} onChange={e=>setF('descricao',e.target.value)}/>
        </div>
      </Modal>
    )}
  </>);
}